/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ideal_Just_Ibex_ThriveInputs */

const es_ideal_just_ibex_thrive = /** @type {(inputs: Ideal_Just_Ibex_ThriveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crear cuenta`)
};

const gl_ideal_just_ibex_thrive = /** @type {(inputs: Ideal_Just_Ibex_ThriveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crear conta`)
};

const en_ideal_just_ibex_thrive = /** @type {(inputs: Ideal_Just_Ibex_ThriveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create account`)
};

/**
* | output |
* | --- |
* | "Create account" |
*
* @param {Ideal_Just_Ibex_ThriveInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const ideal_just_ibex_thrive = /** @type {((inputs?: Ideal_Just_Ibex_ThriveInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ideal_Just_Ibex_ThriveInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_ideal_just_ibex_thrive(inputs)
	if (locale === "en") return en_ideal_just_ibex_thrive(inputs)
	return es_ideal_just_ibex_thrive(inputs)
});